import { SearchQueryRequestType } from '../../common/types';
import { usePostFetch } from '../../utils/reactQuery';
import { pathToUrl } from '../../utils/router';
import { ApiRoutesEnum } from '../../utils/routes';

import { EmailType } from './Emails.type';

export type FetchEmailsResponseType = {
  count: number;
  results: EmailType[];
};

export const useSearchEmails = (payload: SearchQueryRequestType) =>
  usePostFetch<FetchEmailsResponseType>(pathToUrl(ApiRoutesEnum.searchEmails), payload);
